import { IValidationRules } from "@aurelia/validation";
import { IValidationController } from "@aurelia/validation-html";
import { IFormInputOption } from "@components/form/interfaces/form-interface";
import { toastifyError, toastifyInfo, toastifySuccess, toastifyWarning } from "@helpers/toastify";
import { ZeusClient } from "@services/graphql-service/zeus-client";
import { ModelTypes } from "@zeus";
import { inject, newInstanceForScope } from "aurelia";

@inject(IValidationRules, newInstanceForScope(IValidationController), ZeusClient)
export class ComponentsPage {
  private disabledBtn: boolean = false;
  private valueTest: string

  public selectedPreferences: string[] = [];

  public isDisabled: boolean = false;

  private selectedOption: string
  private selectedUser: string
  private selectedItemId: string
  private selectedItem: IFormInputOption

  public checkboxOptions: IFormInputOption[] = [
    { label: 'Opção A', value: 'a' },
    { label: 'Opção B', value: 'b' },
    { label: 'Opção C', value: 'c' }
  ];

  private someFlag: boolean = true

  private numberTest: number

  private componentToShow: string

  private componentOptions: IFormInputOption[] = [
    { label: 'Button', value: 'button' },
    { label: 'Input', value: 'input' },
    { label: 'Textarea', value: 'textarea' },
    { label: 'Inline Message', value: 'inline-message' },
    { label: 'Chip', value: 'chip' },
    { label: 'Select', value: 'select' },
    { label: 'Switch', value: 'switch' },
    { label: 'Checkbox', value: 'checkbox' },
    { label: 'NumberInput', value: 'number-input' },
    { label: 'Typeahead', value: 'typeahead' }
  ]

  private inlineMessageStyle: string

  private inlineMessageStyleOptions: IFormInputOption[] = [
    { label: 'primary', value: 'primary' },
    { label: 'warning', value: 'warning' },
    { label: 'danger', value: 'danger' },
    { label: 'neutral', value: 'neutral' },
    { label: 'success', value: 'success' }
  ]

  private chipColor: string

  private chipColorOptions: IFormInputOption[] = [
    { label: 'primary', value: 'primary' },
    { label: 'secondary', value: 'secondary' },
    { label: 'tertiary', value: 'tertiary' },
    { label: 'danger', value: 'danger' },
  ]

  private chipStyle: string

  private chipStyleOptions: IFormInputOption[] = [
    { label: 'solid', value: 'solid' },
    { label: 'soft', value: 'soft' },
    { label: 'outlined', value: 'outlined' },
  ]

  private chipSize: string

  private chipSizeOptions: IFormInputOption[] = [
    { label: 'lg', value: 'lg' },
    { label: 'md', value: 'md' },
  ]

  private buttonIconSize: string

  private buttonIconSizeOptions: IFormInputOption[] = [
    { label: 'lg', value: 'lg' },
    { label: 'default', value: 'default' },
    { label: 'sm', value: 'sm' },
    { label: 'xsm', value: 'xsm' }
  ]

  private buttonSize: string

  private buttonSizeOptions: IFormInputOption[] = [
    { label: 'lg', value: 'lg' },
    { label: 'default', value: 'default' },
    { label: 'sm', value: 'sm' }
  ]

  private typeaheadOptions: IFormInputOption[] = [];

  constructor(readonly validationRules: IValidationRules,
    readonly validationController: IValidationController, private zeusClient: ZeusClient) {
    validationRules.on(this)
      .ensure('selectedOption').required().withMessage('Campo obrigatório')

      // .ensure('selectedItemId')
      // .required()
      // .withMessage('Campo obrigatório')

      .ensure('selectedItemId')
      .satisfies(() => Boolean(this.selectedItem))
      .withMessage('Campo obrigatório')
      // .when(() => !this.selectedItem)

      // .ensure('selectedItem').required().withMessage('Campo obrigatório')

      .ensure('valueTest').required().withMessage('Campo obrigatório').minLength(5).withMessage('Mínimo 5 caracteres').maxLength(10).withMessage('Máximo 10 caracteres')
      .ensure('numberTest')
      .required().withMessage('Campo obrigatório');
  }

  async validate() {
    await this.validationController.validate();
  }

  teste() {
    alert(`Teste, clique do botão. Valor dos inputs: ${this.valueTest}`)
  }

  async attached() {
    const result = await this.zeusClient.chain('query')({
      users: [
        {
          limit: 20
        },
        {
          id: true,
          displayName: true,
        }
      ]
    })

    this.typeaheadOptions = result.users.map((u: ModelTypes['users']) => {
      return {
        label: u.displayName,
        value: u.id,
      } as IFormInputOption
    })
  }

  async searchCallbackExample(query?: string): Promise<IFormInputOption[]> {

    const result = await this.zeusClient.chain('query')({
      users: [
        {
          where: {
            _and: [
              {
                displayName: {
                  _ilike: `%${query}%`
                }
              }
            ]
          },
          limit: 20
        },
        {
          id: true,
          displayName: true,
        }
      ]
    })

    return result.users.map((u: ModelTypes['users']) => {
      return {
        label: u.displayName,
        value: u.id,
      } as IFormInputOption
    })

  }

  testSuccessAlert() {
    toastifySuccess({ message: 'Operação realizada com sucesso!' });
  }

  testErrorAlert() {
    toastifyError({ message: 'Ocorreu um erro inesperado!' });
  }

  testWarningAlert() {
    toastifyWarning({ message: 'Atenção: Verifique os dados!' });
  }

  testInfoAlert() {
    toastifyInfo({ message: 'Informação importante exibida.' });
  }
}